import { render, staticRenderFns } from "./comment_m.vue?vue&type=template&id=e8f34094&scoped=true"
import script from "./comment_m.vue?vue&type=script&lang=js"
export * from "./comment_m.vue?vue&type=script&lang=js"
import style0 from "./comment_m.vue?vue&type=style&index=0&id=e8f34094&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f34094",
  null
  
)

export default component.exports